
















































































































































































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { activitySessionFields } from '@/config/activities';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { Activity } from '@activities/interfaces/activity';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import Time from '@shared/components/forms/inputs/time/time.vue';
import Datetimepicker from '@shared/components/forms/inputs/datetimepicker/datetimepicker.vue';
import { ActivitySession } from '@activities/interfaces/activity-session';
import { getProp, setProp } from '@shared/helpers/operators';
import TimeRange from '@shared/components/forms/inputs/time-range/time-range.vue';
import { cloneDeep } from 'lodash';
import { Contact } from '@contacts/interfaces/contact';

@Component({
  name: 'bpc-activity-session-game-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-datepicker': Datepicker,
    'bpc-switch': Switch,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
    'bpc-time': Time,
    'bpc-datetimepicker': Datetimepicker,
    'bpc-time-range': TimeRange,
  },
})
export default class ActivitySessionGameForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop([Number, String]) readonly modelId: number | string;
  @Prop(Object) readonly initialData: ActivitySession;
  @Prop(Object) readonly activity: Activity;
  @Prop(Object) readonly team: Contact;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCancelButton: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: ActivitySession;
  @Prop({
    type: String,
  })
  readonly cancelButtonsPortalTarget: string;

  @Prop({
    type: String,
  })
  readonly saveButtonsPortalTarget: string;
  // DATA
  // COMPUTED
  get formModel(): ActivitySession {
    return this.value;
  }

  set formModel(value) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return activitySessionFields;
  }

  get savePath(): string {
    if (this.formModel?.id) {
      return `${this.$bpcApiRouteHelper.getEntityPath('activity-session')}/game/${
        this.formModel.id
      }`;
    }
    return `${this.$bpcApiRouteHelper.getEntityPath('activity-session')}/game`;
  }

  get fetchPath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath('activity-session')}/game/${this.modelId}`;
  }

  get selectedStatus() {
    return this.formModel?.status;
  }

  get isAway() {
    return !!this.formModel?.away;
  }

  get teamName() {
    return this.formModel?.team_name ? this.formModel?.team_name : this.team?.fullname;
  }

  get gameName() {
    if (this.formModel?.away) {
      return `${this.formModel?.opponent_name || ''} vs ${this.teamName || ''}`;
    } else {
      return `${this.teamName || ''} vs ${this.formModel?.opponent_name || ''}`;
    }
  }

  onSaveGameSession(): Promise<BPCGenericApiResponse> {
    return this.$refs.formProvider.saveEntity(this.formModel);
  }

  // LIFE CYCLE
  mounted() {
    if (this.modelId && this.noFetchData) {
      this.formModel = cloneDeep(this.initialData);
    }
  }

  // METHODS
  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.onClose();
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({
      text: 'core.superadmin_form_update_errors',
    });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    // When you create, preset some data after load the default model
    if (!this.modelId) {
      setProp(this.formModel, 'team_name', this.activity?.team?.fullname || this.team?.fullname);
    }
    this.$emit('model-loaded', this.formModel);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  onClose() {
    this.$emit('close');
  }

  prepareToSave(session: ActivitySession) {
    setProp(session, 'type', 'game');
    setProp(session, 'activity_id', this.activity?.id || this.formModel?.activity?.id);
    setProp(
      session,
      'activity_group_id',
      this.activity?.activity_groups[0]?.id || this.formModel.activity?.activity_groups[0]?.id,
    );
    if (!getProp(session, 'away')) {
      setProp(session, 'away', false);
    }
    const responsibleIds =
      session.responsibles?.map(item => (typeof item === 'object' ? item.id : item)) || [];
    setProp(session, 'responsibles', responsibleIds);

    return session;
  }

  get selectedActivity() {
    return this.formModel?.activity || this.activity;
  }

  // WATCHERS
  @Watch('selectedStatus')
  onChangeSelectedStatus(value) {
    if (value !== 'cancelled') {
      setProp(this.formModel, 'cancel_reason', null);
      setProp(this.formModel, 'cancel_reason_description', null);
    }
  }
  @Watch('gameName')
  onChangeGameName(value) {
    setProp(this.formModel, 'name', value);
  }

  @Watch('nameTeam')
  onChangeNameTeam(value) {
    setProp(this.formModel, 'team_name', value);
  }

  @Watch('selectedActivity')
  onChangeSelectedActivity(value) {
    setProp(this.formModel, 'team_name', value?.team?.fullname || this.activity?.team?.fullname);
  }
}
